import ParentAccount from "@/elements/components/account/parent-account";
import TutorAccount from "@/elements/components/account/tutor-account";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment } from "react";

function AccountScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return persona === "parent" ? <ParentAccount /> : persona === "tutor" ? <TutorAccount /> : <Fragment />;
}

export default AccountScreen;
